<div class="dialog course-instructor-wrapper">
  @if (showHeader) {
    @if (isMobileView()) {
      <div class="mobile-app-bar right-action-icons-only sticky-header">
        <h2 class="mobile-app-bar__heading">{{ 'Instructor' | translate }} {{ 'Details' | translate }}</h2>
        @if ((isUserAdmin || isUserAuthor) && !isLoading) {
          <div class="mobile-app-bar__action-icon">
            <app-icon (click)="editInstructor()" iconName="pencil" size="16px"></app-icon>
          </div>
          <div class="mobile-app-bar__action-icon">
            <app-icon (click)="deleteInstructor(this.currentInstructor)" iconName="trash" size="16px"></app-icon>
          </div>
        }
        <div class="mobile-app-bar__action-icon">
          <app-icon (click)="close()" iconName="close" size="16px"></app-icon>
        </div>
      </div>
    } @else {
      <header class="dialog__header">
        <h3 class="dialog__header__title">{{ 'Instructor' | translate }} {{ 'Details' | translate }}</h3>
        <div class="dialog__header__action-buttons">
          @if ((isUserAdmin || isUserAuthor) && !isLoading) {
            <div class="dialog__header__action-buttons__button">
              <span>
                <app-icon (click)="editInstructor()" [cssStyle]="{ margin: '4px' }" iconName="pencil" size="20px"></app-icon>
              </span>
            </div>
            <div class="dialog__header__action-buttons__button">
              <span>
                <app-icon (click)="deleteInstructor(currentInstructor)" [cssStyle]="{ margin: '4px' }" iconName="trash-bin" size="20px"></app-icon>
              </span>
            </div>
          }
          <div class="dialog__header__action-buttons__button">
            <span>
              <app-icon (click)="close()" [cssStyle]="{ margin: '4px' }" iconName="close" size="20px"></app-icon>
            </span>
          </div>
        </div>
      </header>
    }
  }

  @if (!isLoading) {
    <!--  @if (false) {-->

    @if (isUserAuthor) {
      <div [class]="{ 'px-16': isMobileView }">
        <app-alert-message [alertType]="alertType" [denyReason]="currentInstructor?.denyReason" [showCloseIcon]="false" size="small" marginTop="20px"></app-alert-message>
      </div>
    }

    <div class="instructor-header">
      <div class="image-wrapper background-loading">
        <img [appDefaultImage]="'assets/images/defaults/instructor-trim.png'" [src]="currentInstructor.imageUrl" alt="" />
      </div>
      <div class="instructor">
        <h2 class="instructor__name">{{ currentInstructor.fullName }}</h2>
        <p [innerHTML]="currentInstructor.description" class="instructor__description"></p>
      </div>
    </div>

    <div class="instructor-details border-lines">
      @if (currentInstructor?.phoneNo && currentInstructor?.phoneNo !== '0') {
        <div class="flex-row-start-center gap-6">
          <div class="gray-circle">
            <app-icon color="var(--white)" iconName="chat" size="18px"></app-icon>
          </div>
          <div>
            <label class="instructor-details__label" translate>Phone</label>
            <p class="instructor-details__text">{{ currentInstructor.phoneNo }}</p>
          </div>
        </div>
      }
      <div class="flex-row-start-center gap-6">
        <div class="gray-circle">
          <app-icon color="var(--white)" iconName="envelope" size="18px"></app-icon>
        </div>
        <div>
          <label class="instructor-details__label" translate>&#64;-Mail</label>
          <p class="instructor-details__text">{{ currentInstructor.email }}</p>
        </div>
      </div>
      <!--      <div class="flex-row-start-center gap-6">-->
      <!--        <div class="gray-circle">-->
      <!--          <app-icon color="var(&#45;&#45;white)" iconName="globe" size="18px"></app-icon>-->
      <!--        </div>-->
      <!--        <div>-->
      <!--          <label class="instructor-details__label" translate>Web</label>-->
      <!--          <p class="instructor-details__text">{{ currentInstructor.email }}</p>-->
      <!--        </div>-->
      <!--      </div>-->
    </div>

    <div class="about-instructor">
      <app-dynamic-tabs>
        <ng-template [tabName]="'Available Times' | translate">
          <div class="schedule">
            <ul>
              @for (item of instructorAvailability; let i = $index; track item.name + item.time) {
                <li>
                  @if (i === 0 || item.name !== instructorAvailability[i - 1].name) {
                    <span>{{ item.name }}</span>
                  } @else {
                    <i class="--empty">&nbsp;</i>
                  }
                  <span>{{ item.time }} {{ 'Clock' | translate }}</span>
                </li>
              }
            </ul>
          </div>
        </ng-template>

        @if (instructorQualifications && instructorQualifications.length) {
          <ng-template [tabName]="'Qualification' | translate">
            <div class="schedule">
              <ul>
                @for (item of instructorQualifications; let i = $index; track item + i) {
                  <li>
                    <span>{{ item }}</span>
                  </li>
                }
              </ul>
            </div>
          </ng-template>
        }

        <ng-template [tabName]="'More Courses' | translate">
          <div class="schedule">
            <ul>
              @for (item of instructorBookingInOtherCourses; let i = $index; track item + i) {
                <li>
                  <span class="w-250px">{{ item }}</span>
                </li>
              }
            </ul>
          </div>
        </ng-template>

        <!--      <ng-template [tabName]="'Theme' | translate">-->
        <!--        <div class="schedule">-->
        <!--          <p>No Theme</p>-->
        <!--        </div>-->
        <!--      </ng-template>-->
      </app-dynamic-tabs>
    </div>
  } @else {
    <ng-container *ngTemplateOutlet="loader"></ng-container>
  }
</div>

<ng-template #loader>
  <div class="p-16">
    <ngx-skeleton-loader [theme]="{ height: '180px', width: '180px', marginTop: '10px' }" appearance="circle"></ngx-skeleton-loader>
    <ngx-skeleton-loader [theme]="{ height: '50px', marginTop: '20px' }"></ngx-skeleton-loader>
    <ngx-skeleton-loader [theme]="{ height: '60px', marginTop: '10px' }"></ngx-skeleton-loader>
    <ngx-skeleton-loader [theme]="{ height: '100px', marginTop: '20px' }"></ngx-skeleton-loader>
  </div>
</ng-template>
